/**
 * Product feature flags for this release.
 * Flip to `true` when a module is ready to ship again.
 */
export const FEATURES = {
  /** Document upload / AI extraction / apply-to-employee flow */
  documents: false,
} as const;

export type FeatureFlag = keyof typeof FEATURES;
